<template>
  <el-dialog
    :title="isEdit ? 'Редактировать встречу' : 'Создать встречу'"
    :visible.sync="visible"
    width="560px"
    :close-on-click-modal="false"
    @closed="reset"
  >
    <el-form
      size="small"
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      v-loading="loading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Тип встречи" prop="type">
            <el-select v-model="form.type" placeholder="Выберите тип" style="width: 100%">
              <el-option
                v-for="opt in $oneToOneConstants.meetings.typeSelectOptions"
                :key="opt.id"
                :label="opt.name"
                :value="opt.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Формат" prop="format">
            <el-select v-model="form.format" placeholder="Выберите формат" style="width: 100%">
              <el-option
                v-for="opt in $oneToOneConstants.meetings.formatSelectOptions"
                :key="opt.id"
                :label="opt.name"
                :value="opt.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Дата" prop="date">
            <el-date-picker
              v-model="form.date"
              type="date"
              placeholder="Дата"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Время" prop="time">
            <el-time-picker
              v-model="form.time"
              placeholder="Время"
              format="HH:mm"
              value-format="HH:mm:ss"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Длительность (мин.)" prop="planned_duration">
            <el-input-number
              v-model="form.planned_duration"
              :min="5"
              :step="15"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>



      <el-form-item v-if="!isEdit" label="Участник" prop="participant_id">
        <user-select
          v-model="form.participant_id"
          :multiple="false"
          placeholder="Выберите участника"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="Место / ссылка">
        <el-input v-model="form.location" placeholder="Адрес или ссылка на встречу" />
      </el-form-item>

      <el-form-item label="Описание">
        <el-input
          v-model="form.desc"
          type="textarea"
          :rows="3"
          placeholder="Описание встречи"
        />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="small" @click="visible = false">Отмена</el-button>
      <el-button size="small" type="primary" :loading="saving" @click="save">
        {{ isEdit ? 'Сохранить' : 'Создать' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserSelect from "@/components/filters/users/UserSelect.vue";
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";

export default {
  name: 'MeetingEditDialog',
  computed: {
    $oneToOneConstants() {
      return $oneToOneConstants
    }
  },
  components: { UserSelect },

  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      isEdit: false,
      form: {
        id: null,
        type: null,
        format: null,
        date: null,
        time: null,
        planned_duration: 30,
        participant_id: null,
        location: '',
        desc: '',
      },
      rules: {
        type:        [{ required: true, message: 'Выберите тип встречи' }],
        date:        [{ required: true, message: 'Укажите дату' }],
        time:        [{ required: true, message: 'Укажите время' }],
        participant_id: [{ required: true, message: 'Выберите сотрудника' }],
      },
    };
  },

  methods: {
    open(meeting = null) {
      this.isEdit = !!meeting?.id;
      if (this.isEdit) {
        this.form = {
          id:               meeting.id,
          type:             meeting.type,
          format:           meeting.format,
          date:             meeting.date,
          time:             meeting.time,
          planned_duration: meeting.planned_duration,
          participant_id:   meeting.participant_id,
          location:         meeting.location || '',
          desc:             meeting.desc || '',
        };
      }
      this.visible = true;
    },

    reset() {
      this.isEdit = false;
      this.form = {
        id: null, type: null, format: null, date: null, time: null,
        planned_duration: 30, participant_id: null, location: '', desc: '',
      };
      this.$refs.form?.clearValidate();
    },

    save() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.saving = true;

        const apiMethod = this.isEdit ? 'meetingUpdate' : 'meetingCreate';

        this.$api.oneToOne[apiMethod](this.form)
          .then(data => {
            this.$emit('saved', data.meeting);
            this.visible = false;
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
  },
};
</script>